module.exports = __webpack_public_path__ + "img/legalServices-12.5953de1e.png";